import { tenantApi } from '../../../APIs/tenants';
import { TenantCreate } from './TenantCreate';
import { TenantList } from './TenantList';
import { Loading } from '../../atomic/effects';
import { useGet } from '../../../hooks/useApi';

export const SuperAdminTenantIndex = () => {
    const { data } = useGet(tenantApi.get.getTenantsForSuperAdmin);

    const tenants = data?.data;
    if (!tenants) {
        return <Loading />;
    }

    return (
        <div className="app-main admin-tenant">
            <div className="header">
                <h2 className="header-name">テナント一覧</h2>
                <TenantCreate />
                <TenantList tenants={tenants} />
            </div>
        </div>
    );
};
